import { Zap, Skull, BookOpen, Sun } from 'lucide-react';
import React from 'react';

export const REALM_ORDER = ['anime', 'tantra', 'inkspeak', 'soul'];

export const THEMES = {
  anime: {
    id: 'anime',
    label: 'OTAKU',
    bgImage: '/card-bgs/anime.webp',
    colors: {
      bg: 'bg-yellow-300',
      text: 'text-blue-900',
      accent: 'bg-pink-500',
      border: 'border-black',
      card: 'bg-white',
      button: 'bg-blue-600 hover:bg-blue-500 text-white',
    },
    font: 'font-sans tracking-tighter',
    shape: 'rounded-none',
    vibe: 'Glitchy, loud, neon',
    icon: React.createElement(Zap, { size: 48 }),
    sticker: 'CYBER_PUNK_2077',
    decorations: ['ERROR 404', 'SYSTEM_FAILURE', 'WAKE_UP', 'シ'],
    desc: 'Cybernetic dreams & pixelated reality.',
  },
  tantra: {
    id: 'tantra',
    label: 'TANTRA',
    bgImage: '/card-bgs/tantra.webp',
    colors: {
      bg: 'bg-neutral-900',
      text: 'text-red-600',
      accent: 'bg-red-700',
      border: 'border-red-600',
      card: 'bg-black',
      button: 'bg-red-700 hover:bg-red-600 text-black',
    },
    font: 'font-serif tracking-widest uppercase',
    shape: 'rounded-none',
    vibe: 'Gothic, dark, forbidden',
    icon: React.createElement(Skull, { size: 48 }),
    sticker: 'FORBIDDEN',
    decorations: ['†', 'VOID', 'SHADOW', 'BLOOD'],
    desc: 'Shadow work & gothic resonance.',
  },
  inkspeak: {
    id: 'inkspeak',
    label: 'INKSPEAK',
    bgImage: '/card-bgs/inkspeak.webp',
    colors: {
      bg: 'bg-[#f0e6d2]',
      text: 'text-black',
      accent: 'bg-black',
      border: 'border-black',
      card: 'bg-white',
      button: 'bg-black hover:bg-neutral-800 text-white',
    },
    font: 'font-mono',
    shape: 'rounded-sm',
    vibe: 'Literary, brutalist, clean',
    icon: React.createElement(BookOpen, { size: 48 }),
    sticker: 'DRAFT_V1',
    decorations: ['"quote"', 'PAGE_404', 'INK', '¶'],
    desc: 'Wear the words that define you.',
  },
  soul: {
    id: 'soul',
    label: 'SOUL VENTURE',
    bgImage: '/card-bgs/soul.webp',
    colors: {
      bg: 'bg-indigo-100',
      text: 'text-indigo-900',
      accent: 'bg-orange-300',
      border: 'border-indigo-900',
      card: 'bg-white',
      button: 'bg-indigo-600 hover:bg-indigo-500 text-white',
    },
    font: 'font-sans tracking-wide',
    shape: 'rounded-[2rem]',
    vibe: 'Spiritual, soft but heavy',
    icon: React.createElement(Sun, { size: 48 }),
    sticker: 'ALIGNMENT',
    decorations: ['777', 'AURA', 'FLOW', 'ॐ'],
    desc: 'Alignment for the journey within.',
  },
};

export const isValidRealm = (id) => Object.prototype.hasOwnProperty.call(THEMES, id);

export const getTheme = (id) => THEMES[id] || null;
